import { User } from 'src/config/api/models/User';
import { SaveSurvey } from 'src/modules/shared/slices/survey/surveyApi';

export const questionsType = {
  satisfaction: [
    { answer: -2, label: 'zeer ontevreden' },
    { answer: -1, label: 'ontevreden' },
    { answer: 0, label: 'neutraal' },
    { answer: 1, label: 'tevreden' },
    { answer: 2, label: 'zeer tevreden' },
  ],
  rating: [
    { answer: 0, label: '0' },
    { answer: 1, label: '1' },
    { answer: 2, label: '2' },
    { answer: 3, label: '3' },
    { answer: 4, label: '4' },
    { answer: 5, label: '5' },
    { answer: 6, label: '6' },
    { answer: 7, label: '7' },
    { answer: 8, label: '8' },
    { answer: 9, label: '9' },
    { answer: 10, label: '10' },
  ],
};

export const answerInitialValue = -Infinity;

export const getFormInitialValues = (
  data: NonNullable<User['survey']>['questions'] | undefined
): SaveSurvey[] => {
  if (!data) {
    return [];
  }
  const newData: SaveSurvey[] = data?.map((item) => {
    if (item.type === 'multi-choice') {
      return { ...item, multiChoiceAnswer: answerInitialValue.toString() };
    }
    return { ...item, answer: answerInitialValue };
  });
  return newData;
};
